import dayjs, {Dayjs} from "dayjs";

export class DateTimeParser {

    private constructor() {}

    static parseDate(date: string | null | undefined): Dayjs {
        if (date === null || date === undefined) {
            return dayjs(null);
        }
        return dayjs(date, 'YYYY-MM-DD', true);
    }

    static parseTime(time: string | null | undefined): Dayjs {
        if (time === null || time === undefined) {
            return dayjs(null);
        }
        return dayjs(time, ["HH:mm", "HH:mm:ss", "HH:mm:ss.S", "HH:mm:ss.SS", "HH:mm:ss.SSS"], true);
    }

    static parseDateTime(dateTime: string | null | undefined): Dayjs {
        if (dateTime === null || dateTime === undefined) {
            return dayjs(null);
        }
        return dayjs(dateTime);
    }
}